export default "__VITE_ASSET__RYzSGqnI__"